"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MenuButton = _interopRequireDefault(require("../../Shared/MenuButton"));

var _MenuDrawerItem = _interopRequireDefault(require("../../Shared/MenuDrawerItem"));

var _MobileDropdownArrow = _interopRequireDefault(require("../../Shared/MobileDropdownArrow"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var StyledMenuDrawerItem = (0, _styledComponents.default)(_MenuDrawerItem.default).withConfig({
  displayName: "HowItWorks__StyledMenuDrawerItem",
  componentId: "qt0jol-0"
})(["background-color:", ";padding:0 32px;"], function (props) {
  return props.theme.carvana.gray.background;
});

var InnerDrawerItem = _styledComponents.default.div.attrs({
  "data-qa": "inner-drawer-item"
}).withConfig({
  displayName: "HowItWorks__InnerDrawerItem",
  componentId: "qt0jol-1"
})(["flex:1;height:", ";overflow:hidden;transition:height 200ms ease-out;"], function (props) {
  return props.isExpanded ? '359px;' : '60px;';
});

var StyledMenuButton = (0, _styledComponents.default)(_MenuButton.default).withConfig({
  displayName: "HowItWorks__StyledMenuButton",
  componentId: "qt0jol-2"
})(["display:flex;flex:1;height:60px;&:hover{color:", ";text-decoration:none;}"], function (props) {
  return props.theme.carvana.blue.dark;
});

var DropdownWrapper = _styledComponents.default.div.attrs({
  "data-qa": "dropdown-wrapper"
}).withConfig({
  displayName: "HowItWorks__DropdownWrapper",
  componentId: "qt0jol-3"
})(["margin:-15px 0 37px;display:", ";"], function (props) {
  return props.isExpanded ? 'block' : 'none';
});

var DropdownButton = (0, _styledComponents.default)(_MenuButton.default).withConfig({
  displayName: "HowItWorks__DropdownButton",
  componentId: "qt0jol-4"
})(["color:", ";display:flex;flex:1;font-size:12px;font-weight:700;justify-content:flex-start;padding:16px 0 6px 21px;text-decoration:none;letter-spacing:0;"], function (props) {
  return props.theme.carvana.blue.primary;
});

var _ref = _react.default.createElement(DropdownButton, {
  href: "/buying-a-car-online-how-it-works",
  target: "_self"
}, "Buying From Carvana");

var _ref2 = _react.default.createElement(DropdownButton, {
  href: "/selling-or-trades-how-it-works",
  target: "_self"
}, "Selling Or Trading In");

var _ref3 = _react.default.createElement(DropdownButton, {
  href: "/vehicle-protection-plans",
  target: "_self"
}, "Our Protection Plans");

var _ref4 = _react.default.createElement(DropdownButton, {
  href: "/repairs",
  target: "_self"
}, "Repairs with Carvana");

var _ref5 = _react.default.createElement(DropdownButton, {
  href: "/certified-program",
  target: "_self"
}, "Certified Cars");

var _ref6 = _react.default.createElement(DropdownButton, {
  href: "/insurance",
  target: "_self"
}, "Carvana Insurance");

var HowItWorks = function (_PureComponent) {
  _inherits(HowItWorks, _PureComponent);

  function HowItWorks() {
    var _this;

    _classCallCheck(this, HowItWorks);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HowItWorks).call(this));
    _this.state = {
      isExpanded: false
    };
    _this.handleExpansionToggle = _this.handleExpansionToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HowItWorks, [{
    key: "handleExpansionToggle",
    value: function handleExpansionToggle() {
      this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isExpanded = this.state.isExpanded;
      return _react.default.createElement(StyledMenuDrawerItem, {
        "data-qa": "how-it-works"
      }, _react.default.createElement(InnerDrawerItem, {
        isExpanded: isExpanded
      }, _react.default.createElement(StyledMenuButton, {
        onClick: this.handleExpansionToggle,
        disableHref: true
      }, "How It Works", _react.default.createElement(_MobileDropdownArrow.default, {
        isExpanded: isExpanded
      })), _react.default.createElement(DropdownWrapper, {
        isExpanded: isExpanded
      }, _ref, _ref2, _ref3, _ref4, _ref5, _ref6)));
    }
  }]);

  return HowItWorks;
}(_react.PureComponent);

var _default = HowItWorks;
exports.default = _default;
module.exports = exports.default;